import { Tooltip } from '@chakra-ui/tooltip';
const TooltipHorizon = (props: {
  extra: string;
  trigger: JSX.Element;
  content: JSX.Element;
  placement: 'left' | 'right' | 'top' | 'bottom';
}) => {
  const { extra, trigger, content, placement } = props;
  return (
    <Tooltip
      placement={placement}
      label={content}
      zIndex={50}
      position={'relative'}
      className={`relative z-50 w-max rounded-xl bg-white py-3 px-4 text-sm shadow-xl shadow-shadow-500 ${extra}`}
    >
      {trigger}
    </Tooltip>
  );
};

export default TooltipHorizon;
